var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialog)?_c('div',{staticStyle:{"z-index":"99999"},style:({
    position: 'fixed',
    top: '0px',
    left: '0px',
    width: '100%',
    height: _vm.getMaxHeight(),
  }),attrs:{"id":"test"}},[_c('div',{staticClass:"drag-content",on:{"mousedown":function($event){return _vm.onClickOnArea($event)},"mousemove":_vm.mouseMove}},[_c('div',{staticClass:"onCenter dialog-border",style:({
        position: _vm.getPosition(),
        left: _vm.getLeft(),
        top: _vm.getTop(),
        transform: '',
      }),attrs:{"z-index":"1000","id":"myсard"},on:{"mousedown":(ev) => _vm.mouseDown(ev)}},[_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }